import currencies from "src/ipm-shared/store/metadata/currency";

export default {
  convertFromId(
    currencyId: number
  ): {
    $: string;
    code: string;
  } {
    const currency = currencies.find(c => c.id === currencyId);

    return currency
      ? {
          $: currency.prefix_symbol as string,
          code: currency.code as string
        }
      : {
          $: "S$",
          code: "SGD"
        };
  },

  convertFromCurrencyCode(
    currencyCode: string
  ): {
    $: string;
    id: number;
  } {
    if (currencyCode === "HK_USD" || currencyCode === "SG_USD") {
      return {
        $: "US$",
        id: 73
      };
    }

    const currency = currencies.find(c => c.code === currencyCode);

    return currency
      ? {
          $: currency.prefix_symbol as string,
          id: currency.id
        }
      : {
          $: "S$",
          id: 1
        };
  }
};
